// import { Link as RouterLink } from 'react-router-dom';

// material-ui
import {  Stack, Typography } from '@mui/material';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
    <Typography variant="caption">&copy; Developed & Powered by Squarebreed</Typography>
    <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
       <Typography variant="caption" color="inherit" component="div">
        Version 1.2.0
      </Typography>
      {/* <Link
        component={RouterLink}
        to="https://codedthemes.gitbook.io/able-pro-react/"
        target="_blank"
        variant="caption"
        color="textPrimary"
      >
        Documentation
      </Link>
      <Link component={RouterLink} to="https://phoenixcoded.authordesk.app/" target="_blank" variant="caption" color="textPrimary">
        Support
      </Link> */}
    </Stack>
  </Stack>
);

export default Footer;
